/* eslint-disable  prefer-template */

import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

export function ScrollToError() {
    const formik = useFormikContext();
    const submitting = formik?.isSubmitting;

    useEffect(() => {
        if(Object.keys(formik.errors).length > 0){
            const fieldName = Object.keys(formik.errors)[0];
            const element = document.querySelector("input[name='" + fieldName + "']")
            if(element){
                element.focus();
            }
        }
    }, [submitting]);
    return null;
}